<script lang="ts">
    import { dictionary } from "@app/services/currentDictionary.service";
    import Keyboard from "../Keyboard.svelte";
    import {
        activateSearchWidget,
        hideKeyboard,
        toggleKeyboard,
    } from "../Search.store";
    export let dictionarySearchInput: HTMLInputElement;

    const searchContainer = document.getElementById("search-container");

    const dictionarySearchForm = document.getElementById(
        "dictionary-search-form"
    );

    const activator = searchContainer.querySelector("[data-element=keyboard]");

    if (searchContainer && dictionarySearchForm && activator) {
        const targetContainer = document.getElementById("keyboard-container");

        let keyboardWidget: Keyboard;
        activator.addEventListener("click", () => {
            if (!keyboardWidget && targetContainer) {
                const target = document.createElement("div");
                targetContainer.insertBefore(
                    target,
                    targetContainer.firstChild
                );
                keyboardWidget = new Keyboard({
                    target: target,
                    props: {
                        input: dictionarySearchInput,
                        inline: true,
                    },
                });
            }
            toggleKeyboard();
            activateSearchWidget();
        });
        if (dictionarySearchForm) {
            dictionary.subscribe(function (newDictionary) {
                hideKeyboard();
                if (newDictionary.l1.hasSpecialChars) {
                    dictionarySearchForm.classList.remove(
                        "input__without-keyboard"
                    );
                    dictionarySearchForm.classList.add("input__with-keyboard");
                } else {
                    dictionarySearchForm.classList.remove(
                        "input__with-keyboard"
                    );
                    dictionarySearchForm.classList.add(
                        "input__without-keyboard"
                    );
                }
            });
        }
    }
</script>
